import React from 'react';
import './RoundTracker.css';

interface RoundTrackerProps {
  currentRound: number; // 0-based index
  totalRounds: number;
  guessHistory: { guessedLanguage: string; correctLanguage: string; }[];
}

const RoundTracker: React.FC<RoundTrackerProps> = ({ 
  currentRound, 
  totalRounds, 
  guessHistory 
}) => {
  const getRoundStatus = (roundIndex: number) => {
    if (roundIndex < guessHistory.length) {
      // This round has been completed
      const guess = guessHistory[roundIndex];
      return guess.guessedLanguage === guess.correctLanguage ? 'correct' : 'incorrect';
    } else if (roundIndex === currentRound) {
      // This is the current round
      return 'current';
    } else {
      // This is an upcoming round
      return 'upcoming';
    }
  };

  return (
    <div className="round-tracker">
      {Array.from({ length: totalRounds }, (_, index) => {
        const status = getRoundStatus(index);
        return (
          <div 
            key={index}
            className={`round-square ${status}`}
            title={`Round ${index + 1}: ${status}`}
          />
        );
      })}
    </div>
  );
};

export default RoundTracker; 